// extracted by mini-css-extract-plugin
export default {"productGrid":"QZ-z","centerLink":"RZ-z","productSection":"SZ-z","item":"TZ-z","ctaButton":"UZ-z"};